<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("state", 2) }}
      </div>
      <router-link class="btn-blue" to="states"
        >{{ $tc("state", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in States"
          :key="index"
          v-if="item.fieldname !== 'state_id'"
          class="col-lg-6 col-xl-4 mb-4"
        >
          <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.type === 'radio'" class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <label class="ios-switch">
              <input
                type="checkbox"
                class="ios-checkbox"
                v-model="item.fieldvalue"
              />
              <span class="switch-slider"></span>
            </label>
          </div>

          <div v-if="item.type === 'dropdown'">
            <div v-if="item.fieldname === 'country_id'">
              <div class="dropdown-curve-container">
                <label class="shift-up">{{ $tc(item.label, 1) }}</label>
                <b-dropdown
                  :text="item.dropdownSelected"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search country"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCountry()"
                      v-on:keydown="onSearchCountry()"
                      v-on:search="onSearchCountry()"
                      v-model="searchCountry"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(dropdownItem, dropdownIndex) in countryList"
                    :key="dropdownIndex"
                    href="#"
                    @click="
                      onDropdownChange($event, item.label, dropdownItem, index)
                    "
                    >{{ dropdownItem.country_name }}</b-dropdown-item
                  >
                </b-dropdown>

                <p class="error_msg">
                  <span
                    v-if="
                      submitted && item.dropdownSelected === 'Select Country'
                    "
                    >Please select coutry</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="states">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import States from "@/helper/formJSONMaster/States";

export default {
  data() {
    return {
      btenable: false,
      States: States.ms_states,

      Methods: States.Methods,
      submitted: false,
      countryList: [],
      countryListCopy: [],
      searchCountry: ""
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onResetForm: function() {
      this.States.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        }
      });
    },
    onFocusHandler: function() {
      // this.submitted = false;
    },
    getEditList: function(id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("data :");
            let obj = data.details[0];
            console.log("obj :", obj);
            this.States.map((x, index) => {
              if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else if (x.type === "dropdown") {
                x.fieldvalue = obj[x.fieldname];
                // x.dropdownSelected = obj[x.fieldname];
                this.getCountryList(obj[x.fieldname], index);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onSearchCountry: function() {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.countryList = this.countryListCopy.filter(x => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.countryListCopy;
      }
    },
    getCountryList: function(value, index) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries"
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.countryListCopy = data.Records;
            let array = this.countryList.filter(x => x.country_id === value);
            if (value && index && array.length > 0) {
              this.States[index].dropdownSelected = array[0].country_name;
            }
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    onDropdownChange: function(event, type, item, mainIndex) {
      this.States[mainIndex].fieldvalue = item.country_id;
      this.States[mainIndex].dropdownSelected = item.country_name;
    },
    onUpdateHandler: function() {
      // let body = this.getRequestBody("PUT", this.States, {
      //   ...this.Methods,
      //   params: { id: this.$route.query.id }
      // });
      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       console.log("here :", data);
      //       this.$router.push({
      //         path: "/master/states"
      //       });
      //     } else {
      //       console.log("show error :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     console.log("show error :", error);
      //   });

      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.States[3].fieldvalue == "") {
            return;
          } else {
            this.btenable = true;
            let body = this.getRequestBody("PUT", this.States, {
              ...this.Methods,
              params: { id: this.$route.query.id }
            });

            MasterService.GlobalRequest(body)
              .then(response => {
                this.btenable = false;
                const { data } = response;

                if (data.status) {
                  this.$router.push({
                    path: "/master/states"
                  });
                } else {
                  this.$toasted.show(Error(data.message));
                }
              })
              .catch(error => {
                console.log("show error2 :", error);
              });
          }
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/StatesComponents/editState.vue